export default "__VITE_ASSET__DXzRBmMK__"